import React from 'react';
import { Card } from '@/components/ui';
import { Clock } from 'lucide-react';

export function RecentTransactions() {
  const transactions = [
    { title: 'Xuất kho phân bón', area: 'Kho Nông học Thủ Đức', time: '10 phút trước', type: 'out' },
    { title: 'Nhập máy cắt cỏ Honda', area: 'Kho Thiết bị Quận 7', time: '1 giờ trước', type: 'in' },
    { title: 'Điều chuyển vật tư', area: 'Từ Thủ Đức -> Quận 7', time: 'Hôm qua, 14:30', type: 'transfer' },
    { title: 'Kiểm kê định kỳ', area: 'Kho Trung tâm', time: '12/05/2026', type: 'adjust' }
  ];

  return (
    <Card className="bg-white border-2 border-slate-100 shadow-sm rounded-md p-5 h-full flex flex-col">
      <div className="flex-1 relative">
        {/* Vertical Line */}
        <div className="absolute top-6 bottom-6 left-[9px] w-[2px] bg-slate-100" />

        <div className="space-y-4 relative z-10">
          {transactions.slice(0, 4).map((tx, i) => (
            <div key={i} className="flex items-start gap-4">
              {/* Timeline dot */}
              <div className={`flex-shrink-0 mt-3 flex items-center justify-center w-5 h-5 rounded-full bg-white border-[3px] shadow-[0_0_0_4px_white] ${
                tx.type === 'in' ? 'border-blue-500' :
                tx.type === 'out' ? 'border-amber-500' :
                tx.type === 'transfer' ? 'border-purple-500' : 'border-slate-500'
              }`}>
              </div>

              {/* Task Card */}
              <div className={`flex-1 p-3.5 rounded-xl border border-slate-100 bg-white shadow-sm hover:shadow-md transition-all ${
                tx.type === 'in' ? 'hover:border-blue-200' :
                tx.type === 'out' ? 'hover:border-amber-200' :
                tx.type === 'transfer' ? 'hover:border-purple-200' : 'hover:border-slate-300'
              }`}>
                <h4 className="text-sm font-black text-slate-800 mb-1.5">{tx.title}</h4>
                <p className="text-xs text-slate-500 mb-2.5">{tx.area}</p>
                <div className="inline-flex items-center gap-1.5 px-2 py-1 rounded-md bg-slate-50 text-slate-500 text-xs font-medium border border-slate-100">
                  <Clock className="w-3.5 h-3.5 opacity-70" />
                  <span>{tx.time}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}
